module.exports = __webpack_public_path__ + "img/open-hand-black.75c8e39d.svg";